import type { ITimelineEvents } from "@/types/timeline-type";

type TickProps = {
	x: number;
	y: number;
	payload?: ITimelineEvents;
};

export const CustomYAxisTick = ({ x, y, payload }: TickProps) => {
	const size = 24;

	if (!payload) return null;

	return (
		<g transform={`translate(${x},${y})`}>
			<image href={payload.icon} x={-35} y={-10} width={size} height={size} />
		</g>
	);
};

export default CustomYAxisTick;
